module.exports = __webpack_public_path__ + "popup-bg.5f9f29cc6f9a1bb2e460.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portal/popup-bg.png
// module id = 144
// module chunks = 10